import React, { Component } from 'react'
import './BikeListingPhotos.css'
import cloudinary from 'cloudinary-core'
import { CLOUDINARY_NAME } from '../../../constants/images/cloudinary'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import ProgressImage from '../../elements/progressiveImages'
import { trackBikeProfileBrowsedPhotos } from '../../elements/tracking/bikeProfileTracking'
let classNames = require('classnames')
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
})

const responsive = {
  aboveMaxWidth: {
    breakpoint: { max: 6000, min: 1200 },
    items: 1,
  },
  belowMaxWidth: {
    breakpoint: { max: 1199, min: 768 },
    items: 1,
  },

  //keep a mobile breakpoint for sanity later
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },
}

export default class BikeProfilePhotoSlider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      photoIndex: 0,
      isOpen: false,
      slideIndex: 1,
      updateCount: 1,
    }
  }

  render() {
    const { isMobile, bikeData } = this.props

    let bikeHeaderClass = classNames(
      'bike-profile-slider-header-wrap',
      this.props.className,
      {
        'bike-profile-header-mobile': isMobile,
        'has-slider': this.props.profileImages.length > 3,
      }
    )

    let showSlider = true

    if (!isMobile && this.props.profileImages.length === 2) {
      showSlider = false
    }

    if (this.props.profileImages.length === 1) {
      showSlider = false
    }

    return (
      <div>
        {showSlider && (
          <div className={bikeHeaderClass}>
            <div className="multi-view-carousel-wrap">
              <Carousel
                responsive={responsive}
                showDots={false}
                infinite={true}
                keyBoardControl={true}
                centerMode={isMobile ? false : true}
                focusOnSelect
                afterChange={(previousSlide, { currentSlide, onMove }) => {
                  trackBikeProfileBrowsedPhotos()
                  this.setState({
                    slideIndex:
                      currentSlide === 1
                        ? this.props.profileImages.length
                        : currentSlide - 1,
                  })
                }}
              >
                {this.props.profileImages.map((image, index) =>
                  image.bike_image_url == null ||
                    image.bike_image_url === '' ||
                    image.bike_image_url === undefined ? null : (
                    <ProgressImage
                      overlaySrc={image.bike_image_url}
                      src={image.bike_image_url}
                      alt={
                        bikeData.bike_year +
                        ' ' +
                        bikeData.bike_make +
                        ' ' +
                        bikeData.bike_model
                      }
                      className="bike-listing-hero"
                    />
                  )
                )}
              </Carousel>
            </div>
            <div className="bike-slide-show-counter container medium">
              <div className="bike-slide-counter">
                {this.state.slideIndex} of {this.props.profileImages.length}
              </div>
            </div>
          </div>
        )}

        {this.props.profileImages.length === 1 && (
          <div className="hero-image-container single-image">
            <img
              height="600px"
              width="900px"
              src={this.props.profileImages[0].bike_image_url}
              alt={
                bikeData.bike_year +
                ' ' +
                bikeData.bike_make +
                ' ' +
                bikeData.bike_model
              }
              className="bike-listing-hero"
            />
          </div>
        )}

        {this.props.profileImages.length === 2 && !isMobile && (
          <div className="hero-image-container double-image">
            <div className="hero-image-container-double-inner">
              <img
                width="900px"
                height="600px"
                src={this.props.profileImages[0].bike_image_url}
                alt={
                  bikeData.bike_year +
                  ' ' +
                  bikeData.bike_make +
                  ' ' +
                  bikeData.bike_model
                }
                className="bike-listing-hero"
              />
              <img
                width="900px"
                height="600px"
                src={this.props.profileImages[1].bike_image_url}
                alt={
                  bikeData.bike_year +
                  ' ' +
                  bikeData.bike_make +
                  ' ' +
                  bikeData.bike_model
                }
                className="bike-listing-hero"
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}
